<template>
  <div class="serviceDetails">
    <el-form ref="form" label-width="100px">
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="11">
          <el-form-item label="服务单编号">{{curChooseRow.id}}</el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="会员手机号">{{curChooseRow.memberPhone}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="11">
          <el-form-item label="姓名">{{curChooseRow.memberName | filterRow}}</el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="是否预约">{{curChooseRow.isAppoint == 1?'是':'否'}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="11">
          <el-form-item class="lineH" label="服务项目">
            <div v-for="(i,index) in curChooseRow.serviceList" :key="index">{{i.serviceName}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="是否上门">{{curChooseRow.isHome == 1?'是':'否'}}</el-form-item>
          <el-form-item label="上门地址" class="lineH" v-if="curChooseRow.isHome == 1">{{curChooseRow.serviceAddr}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="11">
          <el-form-item label="员工">{{curChooseRow.technicianName}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="11">
          <el-form-item label="服务开始时间">{{curChooseRow.startTime | filterRow}}</el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="服务结束时间">{{curChooseRow.endTime | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
          <el-form-item label="预约时间">{{curChooseRow.scheduleStartTime | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="11">
          <el-form-item label="服务单状态">{{curChooseRow.status | filterAtatus}}</el-form-item>
        </el-col> 
        <el-col :span="11">
          <el-form-item label="创建时间">{{curChooseRow.createTime | formatDateLine}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
          <!-- 已结束 -->
          <el-form-item v-if="curChooseRow.status == 4" label="调理小结" class="lineH" style="word-wrap:break-word;word-break:break-all;">{{curChooseRow.remark | filterRow}}</el-form-item>
          <!-- 已取消 -->
          <el-form-item v-if="curChooseRow.status == 5" label="取消原因" class="lineH" style="word-wrap:break-word;word-break:break-all;">{{curChooseRow.cancelReason | filterRow}}</el-form-item>
        </el-col>
      </el-row>
      <el-row class="btnsOption">
        <el-button class="darkBtn" @click="closeDialog">关闭</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { insertStaff } from "@/api";

export default {
  props:['curChooseRow'],
  data() {
    return {
      form: {}
    };
  },
  methods: {
    closeDialog() {
      // 关闭弹窗
      this.$emit("closeDialog", false);
    }
  }
};
</script>
<style lang="less" scoped>
.serviceDetails {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.serviceDetails {
  .lineH {
    .el-form-item__content {
      line-height: 25px;
      padding-top: 8px;
    }
  }
  .el-form-item__content {
    text-align: left;
    color: #222;
  }
  .el-form-item__label {
    color: #666;
  }
  .btnsOption {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/businessManagementCenter/serviceDetail.vue